// Returns a boolean reflecting if a page has anything selected.
import hasDom from 'has-dom';
export default function hasDocumentSelection() {
  if (hasDom() && window.getSelection() !== null) {
    return window.getSelection().toString().length > 0;
  }
  return false;
}